import { AxiosRequestHeaders } from "axios"

export const DefaultHeaders: AxiosRequestHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json; charset=utf-8",
}
